import React, { useState } from "react";
import "./Testimonial.css";

const testimonials = [
    {
        text: "Indien Buddy helped me surprise my mom with a beautiful cake on her birthday! It made her day special, and I couldn't have done it without their amazing service!",
        author: "Sneha Daruwala, London",
    },
    {
        text: "Sending flowers to my girlfriend in India has never been easier. Indien Buddy truly brings smiles across miles!",
        author: "Rahul Patil, Seattle",
    },
    {
        text: "I wanted to send groceries to my elderly parents in India, and Indien Buddy made it happen seamlessly. Highly recommend!",
        author: "Amit Tiwari, Cologne",
    },
    {
        text: "The best gifting service I have ever used! My Sister was thrilled with the surprise gift delivery. Thank you, Indien Buddy, for making it so special!",
        author: "Hiteshi Khatri, Melbourne",
    },
    {
        text: "Excellent service! The process was easy, and the delivery was on time. My parents were thrilled with the gift.",
        author: "Madhushree Hegde, Toronto",
    },
];

const Testimonial = () => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const handleNext = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
    };

    const handlePrev = () => {
        setCurrentIndex(
            (prevIndex) => (prevIndex - 1 + testimonials.length) % testimonials.length
        );
    };

    const visibleTestimonials = testimonials.slice(
        currentIndex,
        currentIndex + 3
    );

    return (
        <div className="testimonial-carousel">
            <h2>What Our Customers Say</h2>
            <div className="testimonial-wrapper">
                <button onClick={handlePrev} className="nav-btn">
                    &#8592;
                </button>
                <div className="testimonial-cards">
                    {visibleTestimonials.map((testimonial, index) => (
                        <div key={index} className="testimonial-card">
                            <p>"{testimonial.text}"</p>
                            <p className="author">— {testimonial.author}</p>
                        </div>
                    ))}
                </div>
                <button onClick={handleNext} className="nav-btn">
                    &#8594;
                </button>
            </div>
        </div>
    );
};

export default Testimonial;
